var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "DoNotEdit",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-do-not-edit","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <rect width="129.1" height="40.1" x="67.9" y="97.3" className="do-not-edit-pencil" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -44.1474 128.0603)"/>
  <polygon points="79.8,170.1 92.6,182.9 75.1,187.6 57.5,192.3 62.2,174.8 66.9,157.2" className="do-not-edit-pencil"/>
  <path d="M124.9 249.8C56 249.8 0 193.8 0 124.9S56 0 124.9 0s124.9 56 124.9 124.9-56 124.9-124.9 124.9zM42.7 52c-17.3 19.4-27.8 45-27.8 73 0 60.6 49.3 109.9 109.9 109.9 28 0 53.5-10.5 73-27.8L42.7 52zm10.7-10.5l155 155c16.5-19.2 26.5-44.2 26.5-71.5 0-60.7-49.4-110-110-110-27.3 0-52.3 10-71.5 26.5z" className="do-not-edit-circle"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/do-not-edit.svg